
<div class="center">
    <div class="arrowTabs" style="width : 100% !important;">
        <a class="finished"  style="cursor: default !important;">Step 1: Select Training Method</a>
        <a class="finished" style="cursor: default !important;">Step 2 : Upload Supporting Files</a>
        <a class="active" style="cursor: default !important;">Step 3 : Pre-process and Train the System</a>

    </div>
  </div>
<br /><br />


<div class="col-lg-12">
    <div class="panel panel-default" style="box-shadow: 0 2px 8px 0 rgba(0,0,0,0.2);transition: 0.3s;">
        <div class="panel-heading">
            <h3 class="panel-title"><i class="fa fa-bar-chart-o"></i> Chart</h3>
        </div>


        <div id="width" class="panel-body" style="display: flex; align-content:center;padding-left:55px!important;padding-right:55px!important;margin-bottom:0 !important;">
            <br />
            <br />
            <div class="slideScreen">
                <div id="chart" class="w3-display-container mySlides" style="overflow:hidden;">
                    <h3 class="colour" style="text-align:left !important;margin-bottom:30px !important;font-size:22px!important;">
                        Accuracy Overview (No. of records Vs. Accuracy)
                        <span style="display:inline !important;border-left:1px solid #EAEAEA;border-right:1px solid #EAEAEA;padding:0 10px;color:#2D973F;float:right!important;">
                            Total Records :
                            <b>{{total_records}}</b>
                            <span style="display:inline !important;border-left:1px solid #EAEAEA;padding:0 10px;margin-right:0 !important;color:#00A3AE;">
                                Total Categories :
                                <b>{{total_categories}}</b>
                            </span>
                        </span>
                    </h3>
            
                    <div style="border: 2px solid #FCFCFC; background-color:#FCFCFC ">
                        <div class="legend"></div>
                        <div class="chart" style="overflow:auto!important;">
                            <nvd3 [options]="options" [data]="data"></nvd3>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>



<div class="col-lg-12">
    <div class="panel panel-default" style="box-shadow: 0 2px 8px 0 rgba(0,0,0,0.2);transition: 0.3s;">

        <div class="panel-body" style="padding:0!important;">

            <h3 class="heading3" style="text-align:center;">Done !</h3>
            <div class="center">
                <div id="complete" style="color:#2c973e !important;margin:20px 60px 60px 60px !important;font-size:16px;">
                  <img src="./assets/static/icon-green-tick.png" />&nbsp;&nbsp;&nbsp; Training complete 
                  <!-- <span style="color:#999">consolidated_model_file  -->
                  <!-- </span> -->
                </div>
              </div>
            <div class="center">
              <a routerLink = "/Train">
                <button type="button" class="btn btn-lg btn-primary buttonStyle">New Training</button>
              </a>
            </div>

            <br /><br />
        </div>
    </div>
</div>